import { ComponentType } from '@angular/cdk/portal';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertConfig, AppConstants, ConfirmConfig, IDialogService } from '@nibras/core';
import { NIBRAS_CONFIRM_DIALOG_CONFIG, NIBRAS_DIALOG_CONFIG } from '@nibras/core/common';
import { of } from 'rxjs';

export const DIALOG_COMPONENT_TYPE = new InjectionToken<ComponentType<any>>('DialogComponentType');

// TODO service is error prone, it shouldn't mutate input object
@Injectable()
export class DialogService implements IDialogService {
  constructor(
    private dialog: MatDialog,
    @Inject(DIALOG_COMPONENT_TYPE) private dialogComponentType: ComponentType<any>
  ) {}

  public showConfirm(config: ConfirmConfig) {
    if (config && config.rememberKey) {
      const storedValue = localStorage.getItem(config.rememberKey);
      const remember =
        storedValue === 'true' || storedValue === AppConstants.REMEMBER_KEYS.NEVER_ASK_VALUE;
      if (remember) return of(storedValue === 'true');
    }

    this.transformMessage(config);

    config.type = 'confirm';
    return this.dialog
      .open<ComponentType<any>, ConfirmConfig, boolean>(this.dialogComponentType, {
        ...NIBRAS_CONFIRM_DIALOG_CONFIG,
        ...NIBRAS_DIALOG_CONFIG, // TODO should it be first in the order as the less specific?
        ...config,
        data: config
      })
      .afterClosed();
  }

  private transformMessage(config: ConfirmConfig) {
    config.panelClass = [...NIBRAS_DIALOG_CONFIG.panelClass];

    if (config.message && Array.isArray(config.message)) {
      if (config.isLastMessageConfirmation && Array.isArray(config.panelClass)) {
        config.panelClass.push('last-li-confirm');
      }
      config.message = this.makeUL(config.message);
    }
  }

  public showAlert(config: AlertConfig) {
    config.type = 'alert';
    this.transformMessage(config);
    return this.dialog
      .open<ComponentType<any>, AlertConfig, boolean>(this.dialogComponentType, {
        ...NIBRAS_CONFIRM_DIALOG_CONFIG, // TODO should it use NIBRAS_ALTER_DIALOG_CONFIG?
        ...NIBRAS_DIALOG_CONFIG, // TODO should it be first in the order as the less specific?
        ...config,
        data: config
      })
      .afterClosed();
  }

  private makeUL(messages: string[]) {
    return `<ul><li>${messages.join('</li><li>')}</li></ul>`;
  }
}
